module.exports = __webpack_public_path__ + "img/verify1.0aeb81f4.png";